import { render, staticRenderFns } from "./GuestDocumentationBrendanVacations.vue?vue&type=template&id=dd7dbbdc&scoped=true&"
import script from "./GuestDocumentationBrendanVacations.vue?vue&type=script&lang=js&"
export * from "./GuestDocumentationBrendanVacations.vue?vue&type=script&lang=js&"
import style0 from "./GuestDocumentationBrendanVacations.vue?vue&type=style&index=0&id=dd7dbbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7dbbdc",
  null
  
)

export default component.exports